module.exports = __webpack_public_path__ + "static/img/Image_001.3769b00.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/Image_001.png
// module id = yBiv
// module chunks = 3